import React from 'react'
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { appContext } from '../App';

function QuizCard({name, description, color}) {

  const { setNavToggle} = useContext(appContext)


  return (
    <div style={{backgroundColor: color}} className='quiz-card'>

        <p className="heading">{name}</p>
        <p>{description}</p>
        <Link onClick={()=> setNavToggle(true)} to={`/quiz/${name}`}><button>Start Quiz</button></Link>

    </div>
  )
}

export default QuizCard